import { memo, useCallback } from 'react';
import cn from 'classnames';
import { AuthUtils } from 'src/utils';
import { Element, Icon } from 'src/components';
import Menu from 'src/components/menu';
import RouterLink from 'src/components/links';
import useAuth from 'src/hooks/useAuth';

const settingMenu = [
    {
        name: 'Tin cho bạn',
        url: '/tin-cho-ban.epi',
        icon: 'new-award-light',
    },
    {
        name: 'Mục của bạn',
        url: '/muc-cua-ban.epi',
        icon: 'new-folder-light',
    },
    {
        name: 'Theo dõi',
        url: '/theo-doi.epi',
        icon: 'new-rss-light',
    },
    {
        name: 'Đọc gần đây',
        url: '/doc-gan-day.epi',
        icon: 'new-history-light',
    },
    {
        name: 'Tin đã lưu',
        url: '/tin-da-luu.epi',
        icon: 'new-bookmark-light',
    },
];
function DropdownSetting() {
    const { logout } = useAuth();
    const handleLogout = useCallback(() => {
        logout();
    }, []);

    const renderSetting = useCallback(() => {
        return settingMenu.map((item, index: number) => (
            <Menu.List.Item
                key={`parent.${index}`}
                className={cn('border-b border-solid border-b-[#eee]')}
            >
                <RouterLink
                    className={cn(
                        'flex items-center',
                        'h-[48px] w-full',
                        'px-[20px]',
                        'text-black text-[16px] font-[500]'
                    )}
                    to={item.url}
                >
                    <Icon
                        className={cn('text-[24px] mr-[12px]', {
                            ['translate-x-[-5px] rotate-45']:
                                item.icon === 'wifi',
                        })}
                        icon={item.icon}
                    />
                    <Element renderAs="span">{item.name}</Element>
                </RouterLink>
            </Menu.List.Item>
        ));
    }, [settingMenu]);

    return (
        <Menu.List>
            {renderSetting()}
            <Menu.List.Item onClick={handleLogout}>
                <Element
                    className={cn(
                        'flex items-center',
                        'h-[48px] w-full',
                        'px-[20px]',
                        'text-black text-[16px] font-[500]'
                    )}
                    renderAs="button"
                >
                    <Icon
                        className={cn('text-[24px] mr-[12px]')}
                        icon="new-logout-light"
                    />
                    <Element renderAs="span">Đăng xuất</Element>
                </Element>
            </Menu.List.Item>
        </Menu.List>
    );
}

export default memo(DropdownSetting);
